import equal from 'fast-deep-equal/es6/react';

export const compareProps = () => (nextProps: any, lastProps: any) =>
	equal(nextProps, lastProps);
